module.exports = __webpack_public_path__ + "img/featureback1.af49365c.png";